import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import NetworkManager from "../../app/managers/networkManager";
import { config } from "../../app/utils/config";
import { store } from "../../app/store/store";
import { setIsLoading } from "../common/commonSlice";


export const medicalVisitsTypesOptions = {
    conclusion: ['Apte', 'Absent', 'Inapte'],
    validation: ['yes', 'no'],
    is_mid_career: ['yes', 'no'],
    medical_center: ['ACMS', 'AHI 33'],
    type: ['Visite périodique', 'Visite mi-carrière', 'Visite périodique + mi-carrière', 'Visite de reprise', 'À la demande', 'Embauche'],
    type_follow_up: ['Individuel adaptée', 'Individuel simple', 'Individuel adaptée - RQTH', 'Individuel adaptée - NUIT']
}

export const upcomingVisitsStatuses = [
    '0 - En attente de prochaine visite',
    '1 - Demande à envoyer au centre',
    '1b - Absent à replanifier',
    '2 - Demande envoyée',
    '3 - Visite planifié',
    '4 - Attente de retour'
]

export const doneVisitsStatuses = [
    '5 - Validé RH',
    '6 - Visite annulée'
]

const initialState = {
    list: []
}

export const MedicalVisitsSlice = createSlice({
    name: "medicalVisits",
    initialState,
    reducers: {

    },
    extraReducers: (builder) => {
        builder.addCase(getAllMedicalVisits.fulfilled, (state, action) => {
            if (
                action.payload.responseData &&
                action.payload.responseData["list"]
            ) {
                state.list = []
                action.payload.responseData["list"].map(v => {
                    state.list.push({
                        ...v,
                        title: v["title"] && v["title"] != "Inconnu" ? v["title"] : "",
                        theoretical_visit_date: v["theoretical_visit_date"] && new Date(v["theoretical_visit_date"]),
                        planned_visit_date: v["planned_visit_date"] && new Date(v["planned_visit_date"])
                    })
                })
            }
        })
    }
})

export const getAllMedicalVisits = createAsyncThunk(
    "medicalVisits/getAll",
    async (body) => {
        try {
            store.dispatch(setIsLoading(true))
            let response = await NetworkManager.getInstance().postRequest(
                config.apiPaths.medicalVisits.getAll,
                body
            )
            store.dispatch(setIsLoading(false))
            return response
        } catch (error) {
            return error
        }
    }
)

export const updateMedicalVisit = createAsyncThunk(
    "medicalVisits/update",
    async (body) => {
        try {
            store.dispatch(setIsLoading(true))
            let response = await NetworkManager.getInstance().postRequest(
                config.apiPaths.medicalVisits.update,
                body
            )
            store.dispatch(setIsLoading(false))
            return response
        } catch (error) {
            return error
        }
    }
)

export const { } = MedicalVisitsSlice.actions



export default MedicalVisitsSlice.reducer